class TablasPrincipales {
  TablasPrincipales = [];
}

export const tablasPrincipales = new TablasPrincipales();
